import styled from '@emotion/styled';
import { useWindowTitleWithBlur } from '@hotjar/webapp/hooks/useWindowTitle';
import { useTranslation } from 'react-i18next';
import { LimitAlerts } from '../../common/LimitAlerts/LimitAlerts';
import { ResponseAPIGuideCard } from '../ResponsesAPI/GuideCard/ResponsesAPIGuideCard';
import { SurveySideBar } from '../Spaces/SurveySideBar';
import { SurveysList } from './SurveysList';
import { SurveysListHeader } from './SurveysListHeader';

const MainContainer = styled.div`
  display: flex;
`;

const LimitAlertContainer = styled.div`
  > div {
    margin-bottom: 0 !important;
  }
`;

const SurveysListContainer = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
`;

export const SurveysListView = (): JSX.Element => {
  const { t } = useTranslation('feedback');
  useWindowTitleWithBlur(t('survey-list.title'), t('survey-list.title'));
  return (
    <MainContainer>
      <SurveySideBar view="survey-list" selectedWidget={undefined} />
      <SurveysListContainer>
        <SurveysListHeader />
        <ResponseAPIGuideCard />
        <LimitAlertContainer>
          <LimitAlerts
            location="survey-list"
            featureGroup="surveys"
            skippedInstallation={false}
            hidePricingAlert
          />
        </LimitAlertContainer>
        <SurveysList />
      </SurveysListContainer>
    </MainContainer>
  );
};
